import * as actions from "constants/productConstants";
import singleProduct from "data/empty/singleProduct.json";
import { SingleItem } from "types/interfaces";

interface IActions {
  type: string;
  payload?: string;
}

export const productListReducer = (
  state = { products: [] },
  action: IActions
) => {
  switch (action.type) {
    case actions.PRODUCT_MANY_REQUEST:
      return { loading: true };
    case actions.PRODUCT_MANY_REQUEST_SUCCESS:
      return { loading: false, products: action.payload };
    case actions.PRODUCT_MANY_REQUEST_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productUploadReducer = (
  state = { product: {} },
  action: IActions
) => {
  switch (action.type) {
    case actions.PRODUCT_UPDATE_RESET:
      return { product: action.payload };
    case actions.PRODUCT_UPDATE_REQUEST:
      return { loading: true, product: action.payload };
    case actions.PRODUCT_UPDATE_REQUEST_SUCCESS:
      return { loading: false, product: action.payload, redirect: true };
    case actions.PRODUCT_ADD_SUCCESS:
      return { product: action.payload };
    case actions.PRODUCT_ADD_ERROR:
      return { error: "Cannot add Product" };
    default:
      return state;
  }
};

export const productDetailsReducer = (
  state = { products: [] },
  action: IActions
) => {
  switch (action.type) {
    // TODO : Per satu product
    default:
      return state;
  }
};

export const productLatestReducer = (
  state = { products: [] },
  action: IActions
) => {
  switch (action.type) {
    // TODO : Product terbaru
    default:
      return state;
  }
};

export const productTopReducer = (
  state = { products: [] },
  action: IActions
) => {
  switch (action.type) {
    // TODO : Product terpopuler
    default:
      return state;
  }
};

interface productSingleReducerProps {
  (state: { singleProduct: SingleItem }, action: IActions): {};
}

export const productSingleReducer: productSingleReducerProps = (
  state = { singleProduct: singleProduct },
  action: IActions
) => {
  switch (action.type) {
    case actions.PRODUCT_SINGLE_REQUEST:
      return { loading: true, singleProduct: singleProduct };
    case actions.PRODUCT_SINGLE_REQUEST_SUCCESS:
      return { loading: false, singleProduct: action.payload };
    case actions.PRODUCT_SINGLE_REQUEST_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productLikedReducer = (
  state = { likedProducts: [] },
  action: IActions
) => {
  switch (action.type) {
    case actions.PRODUCT_LIKE_REQUEST:
      return { loading: true };
    case actions.PRODUCT_LIKE_SUCCESS:
      return { loading: false, likedProducts: action.payload };
    case actions.PRODUCT_LIKE_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const categoryCountReducer = (
  state = { categoryCount: {} },
  action: IActions
) => {
  switch (action.type) {
    case actions.PRODUCT_CATEGORY_COUNT_REQUEST:
      return { loading: true, categoryCount: state.categoryCount };
    case actions.PRODUCT_CATEGORY_COUNT_SUCCESS:
      return { loading: false, categoryCount: action.payload };
    case actions.PRODUCT_CATEGORY_COUNT_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productReviewReducer = (
  state = { review: {} },
  action: IActions
) => {
  switch (action.type) {
    case actions.PRODUCT_REVIEW_REQUEST:
      return { loading: true, review: {} };
    case actions.PRODUCT_REVIEW_RESET:
      return { loading: false, review: {}, error: false };
    case actions.PRODUCT_REVIEW_SUCCESS:
      return { loading: false, error: false };
    case actions.PRODUCT_REVIEW_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productDeleteReducer = (
  state = { success: false },
  action: IActions
) => {
  switch (action.type) {
    case actions.PRODUCT_DELETE_REQUEST:
      return { loading: true, success: false };
    case actions.PRODUCT_DELETE_SUCCESS:
      return { loading: false, success: true };
    case actions.PRODUCT_DELETE_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
